// Get all orders
export const GET_ORDERS = "GET_ORDERS"
export const GET_ORDERS_SUCCESS = "GET_ORDERS_SUCCESS"
export const GET_ORDERS_FAIL = "GET_ORDERS_FAIL"

// Get order details
export const GET_ORDER = "GET_ORDER"
export const GET_ORDER_SUCCESS = "GET_ORDER_SUCCESS"
export const GET_ORDER_FAIL = "GET_ORDER_FAIL"

// Update order status
export const UPDATE_ORDER_STATUS = "UPDATE_ORDER_STATUS"
export const UPDATE_ORDER_STATUS_SUCCESS = "UPDATE_ORDER_STATUS_SUCCESS"
export const UPDATE_ORDER_STATUS_FAIL = "UPDATE_ORDER_STATUS_FAIL"

// Order confirmation
export const ORDER_CONFIRMATION = "ORDER_CONFIRMATION"
export const ORDER_CONFIRMATION_SUCCESS = "ORDER_CONFIRMATION_SUCCESS"
export const ORDER_CONFIRMATION_FAIL = "ORDER_CONFIRMATION_FAIL"
